export class PartnerAddress {
  city?: string
  countryCode?: string
  countryKey?: string
  partnerCode?: string
  partnerFunction?: string
  partnerID?: string
  poBox?: string
  poBoxPostalCode?: string
  postalCode?: string
  region?: string
  streetHouseNumber1?: string
  streetHouseNumber2?: string
  suburb?: string
  name?: string
}

export class CMSCommentWsDTOCMSCommentWsDTO {
  authorName?: string
  code?: string
  createdAgoInMillis?: number
  creationtime?: Date
  decisionCode?: string
  decisionName?: string
  originalActionCode?: string
  text?: string
}
